import React from "react";
import TextField from "@material-ui/core/TextField";
import { Select, MenuItem } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
// مادر و کودک
class MotherAndKids extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      MothersFullName: "",
      ChildCount: "",
      MothersAge: "",
      PhoneNumber: "",
      Q1: "",
      ChildGender: "پسر",
      InvalidFields: []
    };
    this.props.NextBtn(false);
  }

  DataHandler = () => {
    const { HandleData } = this.props;
    const {
      MothersFullName,
      ChildCount,
      MothersAge,
      PhoneNumber,
      Q1,
      ChildGender,
    } = this.state;
    HandleData({
      MothersFullName,
      ChildCount,
      MothersAge,
      PhoneNumber,
      Q1,
      ChildGender,
    }, 'step3')
  };


  // noinspection DuplicatedCode
  ValidateField = e => {
    const INVALID_FIELDS = this.state.InvalidFields;
    if (e.target.value === "" || e.target.value === 0) {
      INVALID_FIELDS.push(e.target.name);
    } else if (INVALID_FIELDS.includes(e.target.name)) {
      const NAME = e.target.name;
      const INDEX = INVALID_FIELDS.indexOf(NAME);
      INVALID_FIELDS.splice(INDEX, 1);
    }
    this.setState({
      InvalidFields: INVALID_FIELDS
    });

    this.props.NextBtn(this.state.InvalidFields.length === 0);
  }

  Require = (FieldName) => {
    return {
      onBlur: this.ValidateField,
      error: this.state.InvalidFields.includes(FieldName)
    }
  }



  ChangeHandler = (e) => this.setState({ [e.target.name]: e.target.value }, this.DataHandler);

  render() {
    return (
      <div className="row">
        <div className="col-12">
          <div className="row mt-3 w-100">
            <div className="col-12">
              <TextField
                className="w-100"
                name="MothersFullName"
                label="نام و نام خانوادگی مادر"
                defaultValue={this.state.MothersFullName}
                onChange={this.ChangeHandler}
                variant={"outlined"}
                color="secondary"
                {...this.Require("MothersFullName")}
              />
            </div>
          </div>
          <div className="row mt-3 w-100">
            <div className="col-12">
              <TextField
                className="w-100"
                name="ChildCount"
                label="تعداد فرزند"
                type="number"
                defaultValue={this.state.ChildCount}
                onChange={this.ChangeHandler}
                variant={"outlined"}
                color="secondary"
                {...this.Require("ChildCount")}
              />
            </div>
          </div>
          <div className="row mt-3 w-100">
            <div className="col-12">
              <TextField
                className="w-100"
                name="MothersAge"
                label="سن مادر"
                defaultValue={this.state.MothersAge}
                onChange={this.ChangeHandler}
                variant={"outlined"}
                color="secondary"
                {...this.Require("MothersAge")}
              />
            </div>
          </div>
          <div className="row mt-3 w-100">
            <div className="col-12">
              <Typography variant={'h6'} className={'font-weight-bold'}>
                جنسیت کودک :
              </Typography>
              <Select
                variant={'outlined'}
                name={"ChildGender"}
                value={this.state.ChildGender}
                color={"secondary"}
                onChange={this.ChangeHandler}
                className={"col-md-4 col-12 mr-0 mr-md-3"}
              >
                <MenuItem value={"پسر"}>پسر</MenuItem>
                <MenuItem value={"دختر"}>دختر</MenuItem>
              </Select>
            </div>
          </div>
          <div className="row mt-3 w-100">
            <div className="col-12">
              <TextField
                className="w-100"
                name="PhoneNumber"
                label="شماره تماس"
                defaultValue={this.state.PhoneNumber}
                onChange={this.ChangeHandler}
                variant={"outlined"}
                color="secondary"
                {...this.Require("PhoneNumber")}
              />
            </div>
          </div>
          <div className="row mt-3 w-100">
            <div className="col-12">
              <TextField
                className="w-100"
                name="Q1"
                label="تمایل دارید کارگاه در چه زمینه ای به شما و کودکتان کمک کند؟"
                defaultValue={this.state.Q1}
                onChange={this.ChangeHandler}
                variant={"outlined"}
                color="secondary"
                multiline={true}
                rows={1}
                rowsMax={10}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default MotherAndKids;
